import React, { useState } from "react";
import { useEffect } from "react";
import { ToggleInput, ToggleLabel, ToggleSwitch } from "../../atoms/ToggleSwitch";

const Toggle=(props)=>{
    const [checked, setChecked] = useState(props?.value);

    useEffect(()=>{
        setChecked(props?.value)
    },[props?.value])

    const handleChange = (e) => {
      setChecked(e.target.checked);
      props.onToggle();
    };

    return (
        <ToggleLabel marginLeft={props?.marginLeft} marginRight={props?.marginRight} cookies={props?.cookies}>
          <ToggleInput checked={props?.disabled?"true":checked} type="checkbox" onChange={handleChange} />
          <ToggleSwitch disabled={props?.disabled}/>
        </ToggleLabel>
      );

}

export default Toggle;